// extracted by mini-css-extract-plugin
export default {"shareTestContainer":"OYX0Gks51AWYebNmr0Mi","success":"dXRhdNs_1XsMFiPO2XTm"};